import { Link } from "react-router-dom";
import {
  ArrowRight,
  Briefcase,
  Building2,
  Calculator,
  Car,
  Coins,
  FileSpreadsheet,
  HardHat,
  Heart,
  Laptop,
  MessageSquare,
  Percent,
  PiggyBank,
  Ruler,
  Tag,
  TrendingUp,
} from "lucide-react";

/* Se importan uno por uno a propósito. Un `import * as` de lucide-react
   mete las ~1,500 piezas de la librería en el bundle. */
const ICONOS = {
  Briefcase, Building2, Calculator, Car, Coins, FileSpreadsheet, HardHat, Heart,
  Laptop, MessageSquare, Percent, PiggyBank, Ruler, Tag, TrendingUp,
};

export function Icono({ nombre, className = "h-5 w-5" }) {
  const C = ICONOS[nombre] ?? Calculator;
  return <C className={className} aria-hidden="true" />;
}

export default function ToolCard({ tool, n = 0 }) {
  return (
    <Link to={`/${tool.slug}`} className="fila group" style={{ "--i": n }}>
      <span className="texto-3 cifra font-mono text-xs">{String(n + 1).padStart(2, "0")}</span>
      <span>
        <span className="block text-lg leading-snug font-bold">{tool.name}</span>
        <span className="texto-2 block text-sm leading-relaxed">{tool.shortDescription}</span>
      </span>
      <ArrowRight className="fila-flecha texto-3 h-4 w-4 self-center" aria-hidden="true" />
    </Link>
  );
}
